import React, { Component } from 'react';
import './Faqs.Module.css';
import { Container, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { ReactComponent as Chevron } from '../../../assets/images/Vendor/Apple/arrow-cheveron-down.svg';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { UseTranslationInClassComponent } from '../../../components/contexts/LanguageTranslation/UseTranslationInClassComponent';
import { urls } from '../../../components/Vendor/Apple/Footer';
import InternationalPhoneStatic from '../../../components/shared/PhoneNumberUtility/InternationalPhoneStatic';
import { appleServiceNumbers } from '../../../components/_BrandingProvider/brandContent';
import CallLink from '../../../components/shared/PhoneNumberUtility/CallLink';
import { findMyLink } from '../../../components/shared/util';
class Ques extends Component {
    state = {
        open: [],
        searchResults: [],
        totalCount: 0,
        faqQuestionsList: document.querySelectorAll('.faqs .question')
    };

    componentDidMount() {
        this.setState({ faqQuestionsList: document.querySelectorAll('.faqs .question') }, () =>
            this.handleSearch(this.props.searchTerm, true)
        );
    }

    toggle = (e) => {
        const { currentTarget } = e;
        const name = currentTarget.getAttribute('name');
        console.log(name, currentTarget);

        let pos = -1;
        const { open } = this.state;
        if (name) {
            pos = open.indexOf(name);
            if (pos > -1) {
                open.splice(pos, 1);
            } else {
                open.push(name);
            }
        }
        this.setState({ open });
    };

    handleSearch = (searchTerm, isSearchFromMount) => {
        const list = document.querySelectorAll('.faqs .question');
        let updatedFaqList = isSearchFromMount ? list : [...this.state.faqQuestionsList];
        console.log('list', updatedFaqList);
        let searchList = [];
        let number = 1;
        for (var i = 0; i < updatedFaqList.length; ++i) {
            var item = updatedFaqList[i];
            console.log(item);
            console.log(item.innerHTML);
            console.log(item.querySelectorAll('p'));

            if (item.innerText.toLowerCase().includes(searchTerm.toLowerCase())) {
                const allTags = item.querySelectorAll('p');
                allTags[0].innerHTML = number <= 9 ? `0${number}` : number;
                const closestElement = item.closest('.questionCard');
                document.getElementById('searchResults').appendChild(closestElement);
                number++;
                searchList.push(closestElement);
            } else {
                const closestElement = item.closest('.questionCard');
                if (document.getElementById('searchResults').contains(closestElement)) {
                    document.getElementById('searchResults').removeChild(closestElement);
                }
            }
        }
        console.log('s', searchList);

        this.setState({ searchResults: searchList, totalCount: --number });
    };

    render() {
        const { searchTerm, totalCount, searchResults, open } = this.state;
        return (
            <UseTranslationInClassComponent componentPathFromSrcFolder={'screens/Vendor/Apple/Faqs'}>
                {(international) => {
                    const {
                        country,
                        language,
                        countryVars: {
                            currency: { symbol, thousandsDelimiter, decimalDelimiter }
                        },
                        englishVars: { deductibleName },
                        translations
                    } = international;
                    const termsURL = urls[country]?.terms || urls['US']?.terms;
                    const localAppleCustomerServicePhone = appleServiceNumbers.customerService[country];
                    const localApplePhone = appleServiceNumbers.incorrectDevice[country];
                    const customEnglishVarientCountries = ['NZ', 'CL', 'AUS', 'US', 'JP', 'IN', 'MX'];

                    return (
                        <div>
                            <h4
                                className='count'
                                role='status'
                            >
                                {(translations.resultsFound && `${totalCount} ${translations.resultsFound}`)
                                    || `${totalCount} Search Results Found`}
                            </h4>
                            <div id='searchResults'></div>

                            <Container>
                                <div
                                    className='faqs tab-content'
                                    id='tabs-tabContent'
                                >
                                    <div
                                        id='tabsGeneralFAQs'
                                        role='tabpanel'
                                        aria-labelledby='generalFAQs'
                                    >
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='general1'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q1'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('general1') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>01.</p>
                                                        <p>
                                                            {translations.generalQuestionOne
                                                                || 'What is AppleCare+ with Theft and Loss?'}{' '}
                                                        </p>
                                                    </div>

                                                    <div
                                                        className={`${
                                                            open.includes('general1') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('general1')}
                                                aria-labelledby='Q1'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {country === 'US' && (
                                                        <>
                                                            <p>
                                                                AppleCare+ with Theft and Loss is an optional device
                                                                protection program that provides combined benefits under
                                                                a service contract (AppleCare+) for hardware coverage,
                                                                technical support, battery depletion, and accidental
                                                                damage from handling (ADH) and an insurance policy
                                                                (Theft and Loss) that provides benefits for the enrolled
                                                                device including hardware coverage.
                                                            </p>
                                                            <p className='mb-0'>
                                                                To purchase Theft and Loss as a stand-alone insurance
                                                                policy, please see detailed pricing on your
                                                                state-specific{' '}
                                                                <Link
                                                                    to='/vendor/apple/coveragedocs'
                                                                    target='_blank'
                                                                    aria-label='Coverage Documents opens a new details window'
                                                                >
                                                                    Insurance Coverage Documents
                                                                </Link>
                                                                , send an email to{' '}
                                                                <a href='mailto:contractcreation@aig.com'>
                                                                    contractcreation@aig.com
                                                                </a>{' '}
                                                                or call{' '}
                                                                <a
                                                                    href='tel:866-243-6434'
                                                                    className='callLink'
                                                                >
                                                                    <InternationalPhoneStatic
                                                                        number={'(866) 243-6434.'}
                                                                    />
                                                                </a>
                                                            </p>
                                                        </>
                                                    )}
                                                    {country === 'JP' && (
                                                        <p>
                                                            {translations.gq1Prefix
                                                                || 'AppleCare+ with Theft and Loss is an optional device protection program that provides combined benefits under a service contract (AppleCare+) for hardware coverage, technical support, battery depletion, and accidental damage from handling (ADH) and an insurance policy (Theft and Loss) that provides benefits for the enrolled device including hardware coverage.'}
                                                        </p>
                                                    )}
                                                    {country === 'MX' && (
                                                        <p>
                                                            {translations.gq1Prefix
                                                                || 'The Theft and Loss under this Plan is insured by AIG Seguros México S.A. de C.V. (“Insurer”) pursuant to a group insurance policy issued to Apple.'}
                                                        </p>
                                                    )}
                                                    {!customEnglishVarientCountries.includes(country) && (
                                                        <p className='mb-0'>
                                                            {translations.gq1Prefix
                                                                || `AppleCare+ with Theft and Loss is an insurance product that provides expert technical support and hardware coverage, including unlimited incidents of accidental damage protection and up to two incidents of theft or loss coverage every 12 months, each subject to an ${deductibleName?.toLowerCase()}. Coverage begins on your AppleCare+ with Theft and Loss purchase date. For complete details see the `}
                                                            <a
                                                                href={termsURL}
                                                                target='_blank'
                                                                aria-label='terms & conditions'
                                                            >
                                                                {translations.termsLink || 'terms & conditions'}
                                                            </a>
                                                            {translations.gq1PostFix || '.'}
                                                        </p>
                                                    )}
                                                    {country === 'AUS' && (
                                                        <p className='mb-0'>
                                                            The ADH, Theft or Loss Services under the Plan is provided
                                                            to you as a beneficiary under a group policy of insurance
                                                            which Apple has entered into with AIG Australia Limited (ABN
                                                            93 004 727 753, AFS Licence No 381686) of Level 13, 717
                                                            Bourke Street, Docklands Vic 3008, Australia (as “Insurer”)
                                                            in the country or jurisdiction where you purchased the Plan.
                                                        </p>
                                                    )}
                                                    {country === 'NZ' && (
                                                        <p className='mb-0'>
                                                            The ADH and Theft and Loss coverage is provided to you
                                                            pursuant to a group insurance policy that Apple has
                                                            purchased from the Insurer. Apple Sales New Zealand is the
                                                            sole policyholder. For ADH coverage, the Insurer appoints
                                                            Apple to provide the Service Events under Section 3.2 of
                                                            this Plan and covers the costs of such Service Events in
                                                            excess of your service fee. The service fee is payable to,
                                                            and retained by, Apple Sales New Zealand.
                                                        </p>
                                                    )}
                                                    {language === 'en' && country === 'CL' && (
                                                        <>
                                                            <p>
                                                                AppleCare+ and AppleCare+ with theft and loss coverage
                                                                provide priority technical support and hardware
                                                                coverage, plus unlimited accidental damage coverage.
                                                                AppleCare+ with theft and loss coverage includes two
                                                                incidents of theft or loss every 12 months.
                                                            </p>
                                                            <p className='mb-0'>
                                                                AppleCare+ accidental damage from handling coverage and
                                                                AppleCare+ accidental damage from handling and theft and
                                                                loss coverage provided by AppleCare+ with theft and loss
                                                                coverage are provided by Southbridge Insurance Company
                                                                in accordance with the insurance policy issued to Apple.
                                                            </p>
                                                        </>
                                                    )}
                                                    {language !== 'en' && country === 'CL' && (
                                                        <>
                                                            <p>
                                                                AppleCare+ y AppleCare+ con cobertura por robo y pérdida
                                                                brindan soporte técnico prioritario y cobertura de
                                                                hardware, además de cobertura ilimitada por daños
                                                                accidentales. AppleCare+ con cobertura por robo y
                                                                pérdida incluye dos incidentes por robo o pérdida cada
                                                                12 meses.
                                                            </p>
                                                            <p className='mb-0'>
                                                                La cobertura de AppleCare+ por daños accidentales
                                                                originados por el manejo y la cobertura de AppleCare+
                                                                por daños accidentales originados por el manejo y por
                                                                robo y pérdida proporcionadas por AppleCare+ con
                                                                cobertura por robo y pérdida son provistas por
                                                                Southbridge Insurance Company de conformidad con la
                                                                póliza de seguros emitida a Apple.
                                                            </p>
                                                        </>
                                                    )}
                                                    {country === 'IN' && (
                                                        <p className='mb-0'>
                                                            The Accidental Damage from Handling (“ADH”) under this Plan
                                                            is insured by Tata AIG General Insurance Company Limited,
                                                            Peninsula Business Park, Tower- A, 15th Floor, G.K. Marg,
                                                            Lower Parel, Mumbai — 400013, Maharashtra, India (“Tata AIG”
                                                            or “Insurer”) pursuant to an insurance policy issued to
                                                            Apple. The Theft and Loss coverage under this Plan is
                                                            insured by Tata AIG and provided to you as a beneficiary
                                                            under a group insurance policy issued to Apple.
                                                        </p>
                                                    )}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='general2'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q2'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('general2') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>02.</p>
                                                        <p>
                                                            {translations.generalQuestionTwo
                                                                || 'How many claims are covered under a plan?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('general2') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('general2')}
                                                aria-labelledby='Q2'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {country === 'US' && (
                                                        <>
                                                            <p>
                                                                AppleCare+ with Theft and Loss provides coverage for:
                                                                unlimited repairs or replacement for accidental damage
                                                                from handling (ADH) provided by Apple under AppleCare+,
                                                                subject to the per incident service fees listed below;
                                                                and a maximum of 2 replacements per 12-month period from
                                                                your date of purchase for loss or theft under the Theft
                                                                and Loss insurance policy, subject to the per claim{' '}
                                                                {deductibleName?.toLowerCase()} listed below. The
                                                                maximum amount to be paid for any one claim is limited
                                                                to the retail price of your device. There is no claim
                                                                limit for hardware coverage (malfunction after the
                                                                manufacturer’s warranty expires). For specific details
                                                                about the Plan’s claim limits, refer to your
                                                                state-specific{' '}
                                                                <Link
                                                                    to='/vendor/apple/coveragedocs'
                                                                    target='_blank'
                                                                    aria-label='Coverage Documents opens a new details window'
                                                                >
                                                                    Insurance Coverage Documents.
                                                                </Link>
                                                            </p>
                                                            <p className='mb-0'>
                                                                For your lost or stolen claim to be eligible for
                                                                coverage, Find My must be enabled on your device when it
                                                                is lost or stolen.
                                                            </p>
                                                        </>
                                                    )}
                                                    {country !== 'US' && (
                                                        <>
                                                            <p>
                                                                {translations.gq2Prefix
                                                                    || 'AppleCare+ with Theft and Loss provides coverage for: unlimited repairs or replacement for accidental damage from handling (ADH) provided by Apple under AppleCare+, subject to the per incident service fees listed below; and a maximum of 2 replacements per 12-month period from your date of purchase for loss or theft under the Theft and Loss insurance policy, subject to the per claim excess fee listed below. The maximum amount to be paid for any one claim is limited to the retail price of your device. There is no claim limit for hardware coverage (malfunction after the manufacturer’s warranty expires). For specific details about the Plan’s claim limits, refer to your '}
                                                                <Link
                                                                    to='/vendor/apple/coveragedocs'
                                                                    target='_blank'
                                                                    aria-label='Coverage Documents opens a new details window'
                                                                >
                                                                    {translations.gq2CoverageLink
                                                                        || 'Insurance Coverage Documents'}
                                                                </Link>
                                                                {translations.gq2Suffix || '.'}
                                                            </p>
                                                            <p className='mb-0'>
                                                                {translations.gq2SecondParagraph
                                                                    || 'For your lost or stolen claim to be eligible for coverage, Find My must be enabled on your device when it is lost or stolen.'}
                                                            </p>
                                                        </>
                                                    )}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='general3'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q3'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('general3') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>03.</p>
                                                        <p>{translations.generalQuestionThree || 'What is Find My?'}</p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('general3') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('general3')}
                                                aria-labelledby='Q3'
                                                role='region'
                                            >
                                                <CardBody>
                                                    <p className='mb-0'>
                                                        {translations.gq3Prefix
                                                            || 'Find My is an asset tracking service that enables users to track the location of devices through a connected iCloud account. It can be found in the settings on your device. Having this feature activated is a requirement of your AppleCare+ with Theft and Loss agreement. For more information visit '}
                                                        <a
                                                            href={
                                                                findMyLink(language, country)
                                                                ?? 'https://www.apple.com/icloud/find-my/'
                                                            }
                                                            target='_blank'
                                                        >
                                                            {translations.findMyLink || 'Find My'}
                                                        </a>
                                                        {translations.gq3Suffix || '.'}
                                                    </p>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='general4'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q4'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('general4') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>04.</p>
                                                        <p>
                                                            {translations.generalQuestionFour
                                                                || 'Is there a deductible?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('general4') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('general4')}
                                                aria-labelledby='Q4'
                                                role='region'
                                            >
                                                <CardBody>
                                                    <p className='mb-0'>
                                                        {translations.gq4Prefix
                                                            || `A ${deductibleName?.toLowerCase()} will apply per approved theft or loss incident/claim. For specific details about the Plan’s ${deductibleName?.toLowerCase()}, refer to your `}
                                                        <Link
                                                            to='/vendor/apple/coveragedocs'
                                                            target='_blank'
                                                            aria-label='Coverage Documents opens a new details window'
                                                        >
                                                            {translations.gq4CoverageLink
                                                                || 'Insurance Coverage Documents'}
                                                        </Link>
                                                        {translations.gq4Suffix || '.'}
                                                    </p>
                                                </CardBody>
                                            </Collapse>
                                        </Card>

                                        {country === 'US' && (
                                            <>
                                                <Card className='questionCard'>
                                                    <CardHeader
                                                        className='card-header'
                                                        onClick={this.toggle}
                                                        name='general5'
                                                    >
                                                        <div
                                                            className='accordionFaq'
                                                            title='opens a accordian'
                                                            role='button'
                                                            id='Q5'
                                                        >
                                                            <div
                                                                className={`${
                                                                    open.includes('general5') ? 'active' : 'closed'
                                                                } question`}
                                                            >
                                                                <p>05.</p>
                                                                <p>
                                                                    Does AppleCare+ with Theft and Loss cover my Ipad or
                                                                    Watch accessories?
                                                                </p>
                                                            </div>
                                                            <div
                                                                className={`${
                                                                    open.includes('general5') ? 'active' : 'closed'
                                                                } arrow`}
                                                            >
                                                                <Chevron />
                                                            </div>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse
                                                        isOpen={open.includes('general5')}
                                                        aria-labelledby='Q5'
                                                        role='region'
                                                    >
                                                        <CardBody>
                                                            <p className='mb-0'>
                                                                Accessories for the Apple Watch and iPad are not covered
                                                                with Theft and Loss
                                                            </p>
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                                <Card className='questionCard'>
                                                    <CardHeader
                                                        className='card-header'
                                                        onClick={this.toggle}
                                                        name='general6'
                                                    >
                                                        <div
                                                            className='accordionFaq'
                                                            title='opens a accordian'
                                                            role='button'
                                                            id='Q6'
                                                        >
                                                            <div
                                                                className={`${
                                                                    open.includes('general6') ? 'active' : 'closed'
                                                                } question`}
                                                            >
                                                                <p>06.</p>
                                                                <p>How long do I have to file a claim?</p>
                                                            </div>
                                                            <div
                                                                className={`${
                                                                    open.includes('general6') ? 'active' : 'closed'
                                                                } arrow`}
                                                            >
                                                                <Chevron />
                                                            </div>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse
                                                        isOpen={open.includes('general6')}
                                                        aria-labelledby='Q6'
                                                        role='region'
                                                    >
                                                        <CardBody>
                                                            <p className='mb-0'>
                                                                The plan owner must file a claim within the time frame
                                                                indicated in your state-specific{' '}
                                                                <Link
                                                                    to='/vendor/apple/coveragedocs'
                                                                    target='_blank'
                                                                    aria-label='Coverage Documents opens a new details window'
                                                                >
                                                                    Insurance Coverage Documents.
                                                                </Link>
                                                            </p>
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                            </>
                                        )}
                                    </div>
                                    <div
                                        id='tabs-claimFAQs'
                                        role='tabpanel'
                                        aria-labelledby='claimFAQs'
                                    >
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='claims1'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q7'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('claims1') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>01.</p>
                                                        <p>
                                                            {translations.claimProcessQ1
                                                                || 'What is the fastest way to file a claim?'}
                                                        </p>
                                                    </div>

                                                    <div
                                                        className={`${
                                                            open.includes('claims1') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('claims1')}
                                                aria-labelledby='Q7'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {translations.cp1Prefix
                                                        || 'To begin a theft and loss claim, please visit '}
                                                    <a
                                                        href='https://support.apple.com/choose-country-region'
                                                        target='blank'
                                                    >
                                                        support.apple.com
                                                    </a>
                                                    {translations.cp1PrePhone || ' or contact Apple Support at '}
                                                    <CallLink phone={localApplePhone} />
                                                    {translations.cp1Suffix
                                                        || '.  Once you begin your Theft or Loss claim, your device will be erased and disabled. Once your claim is approved, ownership will be transferred to AIG. If you need to complete your claim at a later time, a unique link will be sent to you from AIG.'}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='claims2'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q8'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('claims2') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>02.</p>
                                                        <p>
                                                            {translations.claimProcessQ2
                                                                || 'What information do I need to start a claim?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('claims2') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('claims2')}
                                                aria-labelledby='Q8'
                                                role='region'
                                            >
                                                <CardBody>
                                                    <p>
                                                        {translations.cp2FirstParagraph
                                                            || 'To file a claim you will need the following:'}
                                                    </p>
                                                    <ul className='mb-0'>
                                                        <li>{translations.cp2ListItem1 || 'Apple ID and password.'}</li>
                                                        <li>
                                                            {translations.cp2ListItem2
                                                                || "The claimed device's Serial Number."}
                                                        </li>
                                                        <li>
                                                            {translations.cp2ListItem3
                                                                || 'Information about the claim, including the date of loss.'}
                                                        </li>
                                                        <li>
                                                            {translations.cp2ListItem4
                                                                || 'Email Address to receive updates on the status of your claim or replacement device.'}
                                                        </li>
                                                        <li>
                                                            {translations.cp2ListItem5
                                                                || `A credit card or debit card for your ${deductibleName?.toLowerCase()} payment.`}
                                                        </li>
                                                    </ul>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='claims3'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q9'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('claims3') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>03.</p>
                                                        <p>
                                                            {translations.claimProcessQ3
                                                                || 'What is the importance of providing a valid email during the claims process?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('claims3') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('claims3')}
                                                aria-labelledby='Q9'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {translations.cp3Paragraph
                                                        || "You will receive claim status updates via email with important information regarding your claim. For example, you'll receive an email when your claim is approved and once your replacement device ships and a tracking number is available. Please note, your email address will only be used for claim purposes."}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='claims4'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q10'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('claims4') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>04.</p>
                                                        <p>
                                                            {translations.claimProcessQ4
                                                                || 'How can I check the status of my claim?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('claims4') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('claims4')}
                                                aria-labelledby='Q10'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {translations.cp4Prefix || 'You can '}
                                                    <Link
                                                        to='/vendor/apple'
                                                        target='_blank'
                                                    >
                                                        {translations.login || 'login'}
                                                    </Link>
                                                    {translations.cp4Suffix
                                                        || ' to this portal anytime with your Case ID and Email to easily check the status of your claim. You will receive your Case ID from Apple and AIG upon creating your claim.'}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='claims5'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q11'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('claims5') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>05.</p>
                                                        <p>
                                                            {translations.claimProcessQ5
                                                                || `When is the ${deductibleName?.toLowerCase()} taken?`}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('claims5') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('claims5')}
                                                aria-labelledby='Q11'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {translations.cp5Paragraph
                                                        || `Your card information will be collected when you file your claim. The ${deductibleName?.toLowerCase()} will appear as a pending authorization on your credit card. Once your claim is approved, the payment will be processed. In the event your claim is canceled or denied, the authorization holding those funds will be removed.`}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </div>
                                    <div
                                        id='tabsReplacementFAQs'
                                        role='tabpanel'
                                        aria-labelledby='ReplacementFAQs'
                                    >
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='replacement1'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q12'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('replacement1') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>01.</p>
                                                        <p>
                                                            {translations.replacementDeviceQ1
                                                                || 'How long does it take to receive a replacement device?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('replacement1') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('replacement1')}
                                                aria-labelledby='Q12'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {country === 'US' && (
                                                        <>
                                                            Once your claim is approved, your device is ordered and
                                                            shipped directly from Apple via next-business-day delivery
                                                            Monday through Friday; when available, Saturday delivery may
                                                            be available for an additional fee by contacting Apple at{' '}
                                                            {localApplePhone}.
                                                        </>
                                                    )}
                                                    {country !== 'US' && (
                                                        <>
                                                            {translations.rd1Paragraph
                                                                || 'Once your claim is approved, your device is ordered and shipped directly from Apple via next-business-day delivery Monday through Friday.'}
                                                        </>
                                                    )}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='replacement2'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q13'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('replacement2') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>02.</p>
                                                        <p>
                                                            {translations.replacementDeviceQ2
                                                                || 'How do I activate my replacement device?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('replacement2') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('replacement2')}
                                                aria-labelledby='Q13'
                                                role='region'
                                            >
                                                <CardBody>
                                                    <p>
                                                        {translations.rd2Paragraph
                                                            || 'Enclosed with each replacement is a Quick Start Guide to help you get your replacement device up and running. If your replacement is for a loss or theft claim, please use the instructions below:'}
                                                    </p>
                                                    <ol className='mb-0'>
                                                        <li>
                                                            {translations.rd2ListItem1
                                                                || 'Charge your replacement device'}
                                                        </li>
                                                        <li>
                                                            {translations.rd2ListItem2
                                                                || 'Power on your device and follow on-screen instructions'}
                                                        </li>
                                                        <li>
                                                            {translations.rd2ListItem3Prefix
                                                                || 'Enable Find My, follow the steps provided by '}
                                                            <a
                                                                href='https://support.apple.com/en-us/102648/localeselector'
                                                                target='_blank'
                                                            >
                                                                {translations.rd2ListItem3Link || 'Apple Support'}
                                                            </a>
                                                            {translations.rd2ListItem3Suffix || '.'}
                                                        </li>
                                                    </ol>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='replacement3'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q14'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('replacement3') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>03.</p>
                                                        <p>
                                                            {translations.replacementDeviceQ3
                                                                || 'Does my replacement device have a warranty?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('replacement3') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('replacement3')}
                                                aria-labelledby='Q14'
                                                role='region'
                                            >
                                                <CardBody>
                                                    {translations.rd3Paragraph
                                                        || 'Your replacement device comes with a 90-day warranty or the remainder of your AppleCare+ with Theft and Loss agreement, whichever is longer.'}
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                        <Card className='questionCard'>
                                            <CardHeader
                                                className='card-header'
                                                onClick={this.toggle}
                                                name='replacement4'
                                            >
                                                <div
                                                    className='accordionFaq'
                                                    title='opens a accordian'
                                                    role='button'
                                                    id='Q15'
                                                >
                                                    <div
                                                        className={`${
                                                            open.includes('replacement4') ? 'active' : 'closed'
                                                        } question`}
                                                    >
                                                        <p>04.</p>
                                                        <p>
                                                            {translations.replacementDeviceQ4
                                                                || 'Need help with your replacement?'}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`${
                                                            open.includes('replacement4') ? 'active' : 'closed'
                                                        } arrow`}
                                                    >
                                                        <Chevron />
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <Collapse
                                                isOpen={open.includes('replacement4')}
                                                aria-labelledby='Q15'
                                                role='region'
                                            >
                                                <CardBody>
                                                    <p>
                                                        {translations.rd4Paragraph1Prefix
                                                            || 'For questions regarding your shipment or hardware issues, please contact Apple at '}
                                                        <CallLink phone={localApplePhone} />
                                                        {translations.rd4Paragraph1Suffix || '.'}
                                                    </p>
                                                    <p>
                                                        {translations.rd4Paragraph2
                                                            || 'For mobile service issues, contact your mobile service provider.'}
                                                    </p>
                                                    <p className='mb-0'>
                                                        {translations.rd4Paragraph3Prefix
                                                            || 'For all other issues, please contact us at '}
                                                        <CallLink phone={localAppleCustomerServicePhone} />
                                                        {translations.rd3Paragraph1Suffix || '.'}
                                                    </p>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    );
                }}
            </UseTranslationInClassComponent>
        );
    }
}

export default Ques;
